import { IFilter, IFiltersOptions } from "@/models/tables";
import { FilterTypes, FilterOperators } from "@/data/table";
import i18n from "@/i18n";
import { FraudStatusMap } from "@/data/fraud";
import _ from "@/boot/lodash";
import { InvoiceStatus } from "@/data/enums/invoice";
import { ReferralType } from "@/data/enums/trackedReferrals";

export const trackedReferralsFilters: (
  type: ReferralType
) => IFilter[] = type =>
  _.filter(
    [
      {
        key: "medium",
        label: i18n.t("_.medium"),
        type: FilterTypes.STRING,
        operator: FilterOperators.CONTAINS
      },
      {
        key: "source",
        label: i18n.t("_.source"),
        type: FilterTypes.STRING,
        operator: FilterOperators.CONTAINS
      },
      {
        key: "campaign",
        label: i18n.t("_.campaign"),
        type: FilterTypes.STRING,
        operator: FilterOperators.CONTAINS
      },
      {
        key: "content",
        label: i18n.t("_.content"),
        type: FilterTypes.STRING,
        operator: FilterOperators.CONTAINS
      },
      {
        key: "invoice_id",
        label: i18n.t("_.order_number") as string,
        type: FilterTypes.STRING,
        operator: FilterOperators.EQUAL,
        if: () => type === ReferralType.ORDER
      },
      {
        key: "invoice.status.code",
        label: i18n.t("_.order_status"),
        type: FilterTypes.SELECT_CHECKBOX,
        options: _.sortBy(
          _.map(_.values(InvoiceStatus), code => ({
            value: code,
            label: i18n.t(`_.${code.replace(/^invoice_/, "")}`)
          })),
          ["code"]
        ),
        operator: FilterOperators.EQUAL,
        if: () => type === ReferralType.ORDER
      },
      {
        key: "invoice.product.name",
        label: i18n.t("_.order_item_name"),
        type: FilterTypes.STRING,
        operator: FilterOperators.CONTAINS,
        if: () => type === ReferralType.ORDER
      },
      {
        key: "term",
        label: i18n.t("_.term"),
        type: FilterTypes.STRING,
        operator: FilterOperators.EQUAL
      },
      {
        key: "client.firstname",
        label: i18n.t("_.client_firstname"),
        type: FilterTypes.STRING,
        operator: FilterOperators.EQUAL
      },
      {
        key: "client.lastname",
        label: i18n.t("_.client_lastname"),
        type: FilterTypes.STRING,
        operator: FilterOperators.EQUAL
      },
      {
        key: "client.username",
        label: i18n.t("_.client_username"),
        type: FilterTypes.STRING,
        operator: FilterOperators.EQUAL
      },
      {
        key: "client.fraud_status",
        label: i18n.t("_.client_fraud_status"),
        type: FilterTypes.SELECT_CHECKBOX,
        operator: FilterOperators.EQUAL,
        options: _.map(_.orderBy(FraudStatusMap(), ["id", "asc"]), status => ({
          value: `${status.id}`,
          label: status.label
        })) as IFiltersOptions[]
      },
      {
        key: "created_at",
        label: i18n.t("_.created_at"),
        type: FilterTypes.DATE,
        operator: FilterOperators.EQUAL
      }
    ],
    filter => _.get(filter, "if", () => true)()
  );
